export const normalizeIndicatorStatus = (status: string) =>
  status.trim().replace(/\s+(\S)/g, (_, character: string) => character.toUpperCase())
